<template>
  <div ref="root" class="page01 home container">

    <div class="row title_row">
      <div class="title_num">03</div>
      <h1 class="title" v-html="content.descr" />
    </div>

    <AppTags :list="content.list"/>

    <div class="body_h2" v-html="body.text" />

    <div class="content_title">
      ПРОГНОЗ ЕЖЕГОДНОЙ ДОПОЛНИТЕЛЬНОЙ ПОТРЕБНОСТИ В КАДРАХ
    </div>

    <div class="map">
      <img :src="`${$server}map_base.svg`" class="map_base" data-width="990" data-height="446" />
      <img :src="`${$server}p1/${id}/map.svg`" class="map_info" data-width="990" data-height="446" @error="replaceByDefault" /> <!-- TODO -->
    </div>


    <div class="branches_w">

      <div class="content_title">
        ОТРАСЛИ ЭКОНОМИКИ И ВЕДУЩИЕ РАБОТОДАТЕЛИ
      </div>

      <div class="branches">

        <div v-for="branch of body.branches" :key="branch.id" class="branch_item">
          <img :src="`${$server}p1/${id}/b${branch.id}.svg`" data-width="534" data-height="115" @error="replaceByDefault" />
          <div class="branch_item_body">
            <div class="branch_title" v-html="branch.title" />
            <ul class="branch_list body_ul">
              <li v-for="li of branch.li" v-html="li" />
            </ul>
          </div>
        </div>

      </div>

    </div>

    <div class="qualities">
      <div class="content_title">
        ПРОФЕССИОНАЛЬНО ВАЖНЫЕ КАЧЕСТВА И КОМПЕТЕНЦИИ
      </div>

      <div class="qualities_list_w">
        <div>

          <img :src="`${$server}p1/${id}/big.svg`" class="qualities_list_img" data-width="495" data-height="205" @error="replaceByDefault" />

          <div v-for="quality of qualities.filter(f=>f.col === 'left')" :key="quality.id" class="qualities_list" >
            <div class="qualities_item">
              <img :src="`${$server}p1/${id}/q${quality.id}.svg`" data-width="110" data-height="110" @error="replaceByDefault" />
              <div class="qualities_item_body" v-html="quality.body" />
            </div>
          </div>

        </div>
        <div>

          <div v-for="quality of qualities.filter(f=>f.col === 'right')" :key="quality.id" class="qualities_list" >
            <div class="qualities_item">
              <img :src="`${$server}p1/${id}/q${quality.id}.svg`" data-width="110" data-height="110" @error="replaceByDefault" />
              <div class="qualities_item_body" v-html="quality.body" />
            </div>
          </div>

        </div>

     </div>

    </div>


  </div>
</template>

<script>
import AppTags from '@/components/AppTags.vue'
import {chapterList} from '../content1.js'
import gsap from 'gsap'
require('waypoints/lib/noframework.waypoints.min.js')

export default {
  name: 'Page03',
  data () {
    return {
      content: chapterList,
      list: chapterList.list,
      wpList: [],
      anim: [
        {
          sel: '.branches_w',
          stagger: '.branches_w .branch_item',
          staggerTime: 0.6,
        },{
          sel: '.qualities_list_w',
          stagger: '.qualities_list_w .qualities_item',
          staggerTime: 0.2,
        }
      ],
      // selAnim: '.branch_item .branch_item_body, .qualities_item',
      // staggerAnim: '.branch_item .branch_item_body, .qualities_item',
      confAnim: {opacity: 0},
    }
  },
  watch:{
    $route (to, from){
      this.menuCheck()

      setTimeout( () => {
        this.animSetDefault()
        // this.wp(this.anim[0])
        this.wp(this.anim[1])
      },150)
    }
  },

  computed: {
    id () {
      return this.$route.params.id
    },
    body () {
      return this.content.list.filter(f=>f.id===(this.$route.params.id * 1) )[0]
    },
    qualities () {
      let half = this.body.qualities.length / 3;
      this.body.qualities.map( (m,i) => half > i ? m.col = 'left' : m.col = 'right' )
      return this.body.qualities
    }
  },
  components: {
    AppTags,
  },
  mounted () {
    this.menuCheck()
    this.animSetDefault()
    // this.wp(this.anim[0])
    this.wp(this.anim[1])
  },
  methods: {
    menuCheck() {
      if(this.$store.state.menuOpen) {
        this.$store.dispatch('menuToggle')
      }
    },
    replaceByDefault (e) {
      let w = e.target.getAttribute('data-width')
      let h = e.target.getAttribute('data-height')
      e.target.src = `https://placehold.it/${w}x${h}?text=-`
    },
    animSetDefault () {
      if(this.$isIE) { return }
      // gsap.set(this.anim[0].stagger, this.confAnim)
      gsap.set(this.anim[1].stagger, this.confAnim)
      if(this.wpList.length > 0) {
        this.wpList.map(m=> {m.destroy()} )
        this.wpList = []
      }
    },
    wp(obj) {
      if(this.$isIE) { return }
      const list = Array.prototype.slice.call( this.$refs.root.querySelectorAll(obj.sel) )
      list.map(el => {
        this.wpList.push( new Waypoint({
          element: el,
          offset: '80%',
          handler: (direction) => {
            if(direction === 'down') {
              gsap.to(obj.stagger, 1, {opacity: 1, stagger: obj.staggerTime, y: 0})
            }else{
              // setTimeout(()=>{
                // gsap.set(this.anim[0].stagger, this.confAnim)
                gsap.set(this.anim[1].stagger, this.confAnim)
              // }, 1000)
            }
          }
        }) )

      })
      
    },
  }
}
</script>
<style lang="stylus">
@import '../cofig.styl'

.page01
  .branches_w
    // background #ecf4f8
    background rgb(236, 245, 249, 0.6);
    padding 30px 20px 0 20px
    @media screen and (max-width: 900px)
      padding 20px 10px 0 10px

// .branch_cols
//   column-width: 510px;
//   column-count: 3;
//   column-gap: 30px;

.branches
  padding-top 15px
  padding-bottom 40px
  margin-bottom 30px
  display flex
  flex-wrap wrap
  justify-content center
  .branch_item
    width 100%
    margin-bottom 30px
    display flex
    align-items center
    justify-content space-around
    border-bottom 1px solid rgba(0, 129, 198, 0.3)
    @media screen and (max-width: 900px)
      flex-direction column
    // width 50%
    &:nth-child(even)
      flex-direction row-reverse
      justify-content space-around
      @media screen and (max-width: 900px)
        flex-direction column
      .branch_item_body
        padding-left 0
        padding-right 40px

    &:last-child
      margin-bottom 0
      // padding-bottom 40px
    .branch_item_body
      padding-left 40px
      width: 530px;
      padding-bottom: 15px;
      @media screen and (max-width: 900px)
        width 100%
        padding-left 0
  img
    width: 540px;
    // height 123px
    align-self flex-end
    @media screen and (max-width: 900px)
      width 100%


  .branch_title
    font-size 16px
    line-height 20px
    color $color
    padding-top 12px
    padding-bottom 6px

    
.qualities
  margin-bottom 50px
.qualities_list
  // border 1px solid red
  .qualities_item
    display flex
    flex-wrap wrap
    align-items center
    // @media screen and (max-width: 900px)
      // flex-direction  column
    .qualities_item_body
      $fontBase()
    img
      width 110px
      height 110px
      border-radius 50%
      @media screen and (max-width: 1111px)
        width 10vw
        height 10vw
      @media screen and (max-width: 900px)
        width 25vw
        height 25vw
    div
      width 363px
      padding-left 20px
      @media screen and (max-width: 1111px)
        width 32vw
        padding-left 1.2vw
      @media screen and (max-width: 900px)
        width 65vw
        padding-left 10px

.qualities_list_w
  display flex
  flex-wrap wrap
  justify-content space-between
  margin-top 35px
  &>div
    width 45%
    margin-right 10px
    @media screen and (max-width: 900px)
      width 100%
      margin-right 0
  .qualities_list
    margin-bottom 40px
  .qualities_list_img
    margin-bottom 30px
    width 100%


</style>